<template>
    <MainLayout>
        <div class="container">
            <div class="box">
                <b-button v-if="$hasPermission('stopSale.add')" class="float-right" @click="newModel">Nuevo cierre de venta</b-button>
                <h2>Cierre de ventas</h2>
                <hr>
                <b-form @submit="(evt) => { evt.preventDefault(); this.$root.$emit('bv::refresh::table', 'places-index-list') } ">
                    <div class="row pb-3">
                        <b-form-group class="col-2" label="Nombre">
                            <b-form-input v-model="filters.search" type="text" />
                        </b-form-group>
                        <b-form-group class="col-2" label="Vigencia">
                            <b-form-select v-model="filters.vigency" :options="vigencyOpts"></b-form-select>
                        </b-form-group>

                        <b-form-group class="col-lg-4" label="Aeropuertos">
                            <multiselect
                                v-model="filters.airport"
                                :options="airportsOpts"
                                label="text"
                                track-by="value"
                                placeholder="Todos"
                                :option-height="10"
                                taggable
                            >
                                <template v-slot:clear >
                                    <div class="multiselect__clear" @click="filters.airport = []"></div>
                                </template>
                            </multiselect>
                        </b-form-group>

                        <b-form-group class="col-2" label=".">
                            <b-button type="submit" variant="primary">Buscar</b-button>
                        </b-form-group>
                    </div>
                </b-form>
                <AjaxTable permission-show="stopSale.show" id="places-index-list" :columns="modelColumns" :filters="filters" resource="locks">
                    <template #cell(ratePlan)="row">
                        <div v-if="row.item.ratePlan != null">
                            {{ row.item.ratePlan.name }}
                        </div>
                    </template>
                    <template #cell(actions)="row">
                        <div class="text-center">
                            <b-button  @click="(event) => editModel(row.item.id)" type="button" size="sm" class="mr-1" variant="info">
                                <md-icon icon="edit" />
                            </b-button>
                            <b-button v-if="$hasPermission('stopSale.delete')" @click="(event) => modelDelete(row.item,row.index,event)" type="button" size="sm" class="mr-1" variant="danger">
                                <md-icon icon="delete" />
                            </b-button>
                        </div>
                    </template>
                </AjaxTable>
            </div>
        </div>
        <Single :unableEdit.sync="unableEdit" ref="single" :success-callback="successCallback" />
    </MainLayout>
</template>

<script>

    import Multiselect from "vue-multiselect";
    import MainLayout from '../layout/MainLayout.vue'
    import AjaxTable from '../../helpers/AjaxTable.vue'
    import Single from './Single.vue'
    import api from '../../../api.js'

    export default {
        components: {MainLayout, AjaxTable, Single, Multiselect},
        data() {
            return {
				unableEdit: false,
                filters : {
                    search:'',
                    vigency: 'current',
                    airport: []
                },
                modelColumns: [
                    {key: 'id',             label: 'ID'},
                    {key: 'description',    label: 'Descripción'},
                    {key: 'startDateH',     label: 'Inicio'},
                    {key: 'endDateH',       label: 'Fin'},
                    {key: 'ratePlan.title', label: 'Plan tarifario'},
                    {key: 'status',         label: 'Estatus'},
                    {key: 'actions',        label: 'Acciones'}
                ]
            }
        },
        methods: {
            successCallback() {
				this.$root.$emit('bv::refresh::table', 'places-index-list')
			},
			editModel(id) {
				this.unableEdit = !this.$hasPermission('stopSale.edit')
				this.$refs['single'].loadModel(id)
			},
            newModel() {
				this.unableEdit = false
                this.$refs['single'].loadModel(-1)
            },
            modelDelete(item) {
				this.$root.showWarning({
					okAction: (event, setLoading, close) => {
						setLoading(true)
						api(this).delete(`/locks/${item.id}`).then((response) => {

							if (response.data.error) {
								this.$root.showAlert(response.data.message, {variant: 'warning'})
								close()
								return false
							}

							this.$root.showAlert('Registro Eliminado!', {variant: 'warning'})
							this.$root.$emit('bv::refresh::table', 'places-index-list')
							this.$root.auxVars.loadResourcesOpts({vm: this, resourceNames: ['destinationsOpts'],forceRefresh: true})
							close()
						}).catch(err => {
							this.$root.handleRequestError(err)
							close()
						});
					}
				})
			},
        },
        computed: {
            vigencyOpts() {
                return [
                    { value: 'current',  text: "Vigentes"},
                    { value: 'expired',  text: "Caducados"},
                    { value: 'to_apply', text: "Por aplicar"},
                    { value: '',        text: "Todos"}
                ]
            },
            airportsOpts() {
                let aux= [...this.$root.auxVars.airportsOpts.map((air) => ({
                    value: air.id,
                    text: air.name,
                }))];
                return aux;
            },
        }
    }

</script>
